import { Component, Injector, Optional, Input } from '@angular/core';

import { ConditieService } from 'src/app/core/service/conditie.service';
import { Conditie } from 'src/app/core/dto/conditie';
import { Filter, FilterBuilder, PagedCollectionComponent, ColumnDefinition, createColumnDefinitions, SearchableType } from '@mango/core';
import { Relatie } from 'src/app/core/dto/relatie';

@Component({
    selector: 'c-i-j-borculo-conditie-collection',
    templateUrl: './conditie-collection.component.html'/*,
    styleUrls: ['./conditie-collection.component.css'] */
})
export class ConditieCollectionComponent extends PagedCollectionComponent<Conditie> {
    columnDefinitions: ColumnDefinition[] = createColumnDefinitions<Conditie>([
		{ colDef: 'rubriekID', prop: x => x.rubriekID.titel, searchable: SearchableType.String },
		{ colDef: 'korting', prop: x => x.korting, searchable: SearchableType.Number }
    ]);
    displayedColumns = this.columnDefinitions.map(x => x.colDef);

    constructor(public service: ConditieService, @Optional() protected filter: Filter<Conditie>, injector: Injector) {
        super('/conditie/conditie', injector, Conditie);

        this.initInput('relatieID', this.filterBuilder.equal(x => x.relatieID.id));

        this.filter.onGetChipLabel(x => x.rubriekID.titel, () => 'Rubriek');
		this.filter.onGetChipLabel(x => x.korting, () => 'Korting');

    }

	displayColumn(colDef: ColumnDefinition, ix: number) {
		// Hide columns that are already filtered on
		if(colDef.colDef == 'relatieID' && this.relatieID != null) { return false; }

		return super.displayColumn(colDef, ix);
	}

	@Input() set relatieID(val: Relatie) { this.handleInput('relatieID', val.id); }
}